"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OcppIdTokenAuthorizationStatusValidation = void 0;
class OcppIdTokenAuthorizationStatusValidation {
    static isValid(enumValue) {
        if (typeof enumValue !== "number")
            return false;
        if (!(0 <= enumValue && enumValue <= 6)) {
            return false;
        }
        return true;
    }
}
exports.OcppIdTokenAuthorizationStatusValidation = OcppIdTokenAuthorizationStatusValidation;
